import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Coffee, Smartphone, Zap, Star, Layout, ArrowRight, Palette, ShieldCheck } from 'lucide-react';
import MobileNav from '../components/MobileNav';

// Asset imports
import logo from '../data/banner/logo-xoa-background.png';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white text-slate-900 font-sans">
      {/* Navigation */}
      <MobileNav showDesignButton={false} />


      {/* Functional Hero Section */}
      <section className="py-16 px-4 md:px-6 max-w-7xl mx-auto text-center">
        <div className="space-y-6">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900">
            Công Cụ Thiết Kế Sản Phẩm
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            Lựa chọn sản phẩm bạn muốn bắt đầu thiết kế dưới đây.
            Hệ thống hỗ trợ tự động căn chỉnh và xem trước 3D chuyên nghiệp.
          </p>

          <div className="flex flex-col sm:flex-row gap-5 justify-center pt-8">
            <button
              onClick={() => navigate('/phone-case')}
              className="flex items-center justify-center gap-4 bg-slate-900 text-white px-10 py-5 rounded-2xl font-bold text-xl hover:bg-slate-800 transition-all shadow-xl active:scale-95"
            >
              <Smartphone className="w-7 h-7" />
              <span>Thiết Kế Ốp Lưng</span>
            </button>
            <button
              onClick={() => navigate('/cup-customizer')}
              className="flex items-center justify-center gap-4 bg-white text-slate-900 px-10 py-5 rounded-2xl font-bold text-xl border-2 border-slate-200 hover:border-slate-300 transition-all active:scale-95 shadow-sm"
            >
              <Coffee className="w-7 h-7" />
              <span>In Cốc Logo</span>
            </button>
          </div>
        </div>
      </section>

      {/* Functional Features - No fluff */}
      <section className="py-20 bg-gray-50 border-y border-gray-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="text-3xl font-bold mb-12 text-center text-slate-800">Khả Năng Hệ Thống</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {[
              {
                icon: Layout,
                title: "Mô Phỏng 3D Chuẩn",
                desc: "Hiển thị mô phỏng ốp lưng và cốc trong không gian 3 chiều với độ chính xác cao."
              },
              {
                icon: Zap,
                title: "Layout Thông Minh",
                desc: "Hệ thống tự động đặt logo và hình ảnh vào vị trí tối ưu, cân bằng tỷ lệ."
              },
              {
                icon: Palette,
                title: "Tối Ưu Bản In",
                desc: "Tự động xóa nền, tăng độ nét và chuẩn hóa màu sắc trước khi xuất file in."
              }
            ].map((feature, i) => (
              <div key={i} className="flex flex-col gap-5 p-8 bg-white rounded-3xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                <div className="w-14 h-14 shrink-0 bg-slate-50 rounded-2xl flex items-center justify-center text-slate-800">
                  <feature.icon className="w-7 h-7" />
                </div>
                <div>
                  <h3 className="font-bold text-xl mb-2">{feature.title}</h3>
                  <p className="text-slate-500 leading-relaxed">{feature.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Simplified Footer */}
      <footer className="py-16 border-t border-gray-100 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex flex-col md:flex-row justify-between items-center gap-10">
          <img src={logo} alt="Veritas Logo" className="h-16 md:h-24 w-auto object-contain opacity-90" />
          <div className="text-slate-400 text-sm font-medium">
            © 2024 Veritas Studio. Giải pháp thiết kế & in ấn cá nhân hóa.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
